// extracted by mini-css-extract-plugin
module.exports = {"pagetitlebox":"styles_pagetitlebox__Sb8q5","marginleft1":"styles_marginleft1__Yjnqx","marginright03":"styles_marginright03__bu_hs","pagetitlebox1":"styles_pagetitlebox1__3s8co"};